<template>
  <div class="organization-concepts-tab">
    <v-row>
      <v-col cols="12">
        <v-card
          :loading="conceptsLoading || organizationConceptsLoading"
          :disabled="conceptsLoading || organizationConceptsLoading"
        >
          <v-card-title>Available Concepts</v-card-title>
          <v-text-field
            class="ma-2"
            v-model="search"
            clearable
            hide-details
            prepend-inner-icon="search"
            label="Search"
          ></v-text-field>
          <v-row class="ma-1">
            <v-col xs="12" sm="6" md="4" v-for="concept in filteredConcepts" :key="concept.uuid">
              <v-card>
                <div class="d-flex flex-no-wrap justify-space-between">
                  <div>
                    <v-card-title>{{concept.label}}</v-card-title>
                  </div>
                  <v-avatar class="ma-3" size="125" tile>
                    <v-img :src="concept.logo" contain></v-img>
                  </v-avatar>
                </div>
                <v-card-actions>
                  <v-btn
                    :disabled="!organizationConceptsUuids.includes(concept.uuid)"
                    color="primary"
                    small
                    rounded
                    @click="openConcept(concept)"
                  >
                    <v-icon left small>people</v-icon>
                    <span>Manage Users</span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import mixin from "@/mixins";
export default {
  mixins: [mixin],
  props: {
    organizationConcepts: { type: Array, required: true },
    concepts: { type: Array, required: true },
    organizationConceptsLoading: { type: Boolean, required: true },
    conceptsLoading: { type: Boolean, required: true }
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    filteredConcepts() {
      return this.concepts.filter(concept =>
        concept.label.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    importedConcepts() {
      return this.concepts.filter(concept =>
        this.organizationConceptsUuids.includes(concept.uuid)
      );
    },
    organizationConceptsUuids() {
      return this.organizationConcepts.map(concept => concept.uuid);
    }
  },
  methods: {
    openConcept(concept) {
      this.$emit("openConcept", concept);
    },
    findConcept(concept) {
      return this.organizationConcepts.find(loc => loc.uuid == concept.uuid);
    }
  }
};
</script>

<style>
</style>